import React from 'react';

// styling
import { Colors, Spacing } from '_styles';

const Modal = (props) => {
    const styles = {
        modal: {
            position: 'fixed',
            top: '10vh',
            left: '50%',
            transform: 'translateX(-50%)',
            width: '90%',
            maxWidth: Spacing.SCALE_300,
            backgroundColor: Colors.GRAY_LIGHT,
            borderRadius: Spacing.SCALE_10,
            boxShadow: '0 10px 30px rgba(0, 0, 0, 0.3)',
            zIndex: 1000,
            overflow: 'hidden',
            display: 'flex',
            flexDirection: 'column',
        },
        backdrop: {
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            zIndex: 999,
        },
    };

    return (
        <div style={styles.backdrop}>
            <div style={styles.modal}>
                {props.children}
            </div>
        </div>
    );
};

export default Modal;
